// ไฟล์: frontend/src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className="main-footer">
      <div className="d-flex align-items-center">
        <img 
          src="https://www.i-pic.info/i/krVq1004512.jpg" 
          alt="logo" 
          className="footer-logo"
        />
        <div>
          <strong>พัฒนาโดย Devtaiban</strong> <a href="http://www.Kruwirat.com" target="_blank" rel="noopener noreferrer">www.Kruwirat.com</a>
          <div className="d-block">
            <small>Tel: 095-602-9737</small>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;